import { IGetState, TBoardId, TListId } from '../types/types';
import { Dispatch, ThunkAction } from '../types/actions';
import { getBoardPermissionsAllowEdit } from '../store/model/selectors/getBoardPermissionsAllowEdit';
import { root } from '../store/constants';
import { updateSelectedLists } from '../view/react_components/clickManager/effects/updateSelectedLists';
import { getList } from '../store/model/list/selectors/getList';

export const openMultiListForm = (
    boardId: TBoardId,
    listIds: TListId[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const isMultiselectPanel = document.querySelector('.multiselect__list') as HTMLElement;

        if (!getBoardPermissionsAllowEdit(state, boardId)) {
            return root.App.router.navigate(root.App.router.getUrl(null), { trigger: true });
        }
        const lists = listIds.map(listId => getList(state, listId)).filter(list => !!list);
        dispatch(updateSelectedLists(boardId, lists.map(list => list.id)));
        if (!lists.length) { // ссылка на удалённые листы - сбросить ссылку
            return root.App.router.navigate(root.App.router.getUrl(null), { trigger: true });
        }
        if (!isMultiselectPanel) {
            root.App.controller.asidePanel.showMultiList(boardId);
        }
    };
    return action;
}
